import Navbar  from "../NavBar/NavBar.js";
import Footer from "../Home/Footer.js"
import Whatsapp from "../Home/Whatsapp.js";
import AT from "./groupe_pages/AT/AT.js"
import AT22 from "./groupe_pages/AT/AT22.js"
import AT33 from "./groupe_pages/AT/AT33.js"
import Spinner from "../Home/Spinner.js";
import { useEffect } from "react";




const ArchitectureTextil = () => {
  useEffect(() => {
    // ✅ TITLE (SEO + mots clés + Maroc)
    document.title =
      "Architecture Textile Maroc | Structures & Voiles d’Ombrage – UNIK SYSTEM";

    // ✅ DESCRIPTION (قوية + CTA)
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Spécialiste en architecture textile au Maroc : structures métallo-textiles, voiles d’ombrage et solutions design pour espaces extérieurs. Qualité, durabilité et design sur mesure. Devis gratuit."
    );

    // ✅ KEYWORDS
    let keywords = document.querySelector("meta[name='keywords']");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.setAttribute("name", "keywords");
      document.head.appendChild(keywords);
    }
    keywords.setAttribute(
      "content",
      "architecture textile maroc, structure textile tendue, voile d'ombrage maroc, structure metallotextile maroc, ombrage design maroc, facade textile maroc, tensile structure maroc"
    );

    // ✅ ROBOTS
    let robots = document.querySelector("meta[name='robots']");
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "index, follow");

    // ✅ CANONICAL
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute(
      "href",
      "https://unik-system.com/architecture-textile-maroc"
    );

    // ✅ OPEN GRAPH
    const setMetaProperty = (property, content) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMetaProperty(
      "og:title",
      "Architecture Textile Maroc – UNIK SYSTEM"
    );
    setMetaProperty(
      "og:description",
      "Structures textiles, voiles d’ombrage et solutions design pour extérieur au Maroc."
    );
    setMetaProperty(
      "og:image",
      "https://unik-system.com/static/media/27Voiles%20d%E2%80%99ombrage%20multiples%20sur%20espace%20public%20%E2%80%93%20solution%20US%20SHADE%20haute%20r%C3%A9sistance%20UV.501adbd8dede52302718.webp"
    );
    setMetaProperty(
      "og:url",
      "https://unik-system.com/architecture-textile-maroc"
    );
    setMetaProperty("og:type", "website");

    // ✅ TWITTER
    let twitterCard = document.querySelector("meta[name='twitter:card']");
    if (!twitterCard) {
      twitterCard = document.createElement("meta");
      twitterCard.setAttribute("name", "twitter:card");
      document.head.appendChild(twitterCard);
    }
    twitterCard.setAttribute("content", "summary_large_image");

    let twitterImage = document.querySelector("meta[name='twitter:image']");
    if (!twitterImage) {
      twitterImage = document.createElement("meta");
      twitterImage.setAttribute("name", "twitter:image");
      document.head.appendChild(twitterImage);
    }
    twitterImage.setAttribute(
      "content",
      "https://unik-system.com/static/media/27Voiles%20d%E2%80%99ombrage%20multiples%20sur%20espace%20public%20%E2%80%93%20solution%20US%20SHADE%20haute%20r%C3%A9sistance%20UV.501adbd8dede52302718.webp"
    );

  }, []);


    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <AT/>
            <AT22/>
            <AT33/>
            <Footer/>
        </div>    
    )
};

export default ArchitectureTextil;